export const NEW_TAB_LINK_TARGET = '_blank'
